import { Phone, MessageCircle } from "lucide-react";

// Click-to-call + WhatsApp deep-link for OTA rows in the Bookings list.
// Same 32px icon style used by ReceptionTab's ContactActions so hosts have
// the exact same one-tap CRM in both views. Phone comes from the iCal
// `extracted.phone` (Booking.com messages include it) or the channel API.
export default function OtaContactButtons({ booking, IT }) {
  const phone = (booking.guest_phone || "").trim();
  if (!phone) {
    return (
      <span className="text-[10px] italic text-muted-foreground whitespace-nowrap" data-testid={`ota-contact-none-${booking.id}`}>
        {IT ? "Nessun telefono" : "No phone"}
      </span>
    );
  }
  const waNumber = phone.replace(/[^\d]/g, "");
  const firstName = (booking.guest_name || "").split(" ")[0] || (IT ? "Ospite" : "Guest");
  const roomLabel = booking.room_name && booking.room_name !== "—" ? ` in ${booking.room_name}` : "";
  const ci = booking.check_in || "";
  const dateLabel = ci ? (IT ? ` per il ${ci}` : ` on ${ci}`) : "";
  const etaLink = booking.session_id
    ? `${window.location.origin}/guest/portal/${booking.session_id}`
    : "";
  const etaLine = etaLink
    ? (IT
        ? `\n\n👉 Rispondi con un tap qui: ${etaLink}`
        : `\n\n👉 Reply with one tap here: ${etaLink}`)
    : "";
  const msg = IT
    ? `Ciao ${firstName}! 👋 Ti scrivo per la tua prenotazione${roomLabel}${dateLabel}. Per organizzare al meglio la tua accoglienza, comunicaci con precisione l'orario previsto di arrivo (anche approssimativo).${etaLine}\n\nA presto! 🙌`
    : `Hi ${firstName}! 👋 I'm reaching out about your reservation${roomLabel}${dateLabel}. To arrange the best welcome, please tell us your expected arrival time (even approximate).${etaLine}\n\nSee you soon! 🙌`;
  const waUrl = `https://wa.me/${waNumber}?text=${encodeURIComponent(msg)}`;
  return (
    <>
      <a
        href={`tel:${phone}`}
        onClick={(e) => e.stopPropagation()}
        className="inline-flex items-center justify-center w-7 h-7 rounded-full border border-border text-primary hover:bg-primary hover:text-primary-foreground transition-all"
        title={IT ? `Chiama ${phone}` : `Call ${phone}`}
        data-testid={`ota-contact-call-${booking.id}`}
      >
        <Phone className="w-3 h-3"/>
      </a>
      <a
        href={waUrl}
        target="_blank"
        rel="noreferrer"
        onClick={(e) => e.stopPropagation()}
        className="inline-flex items-center justify-center w-7 h-7 rounded-full text-white bg-[#25D366] hover:bg-[#128C7E] transition-all"
        title={IT ? "Apri WhatsApp con messaggio pre-compilato" : "Open WhatsApp with pre-filled message"}
        data-testid={`ota-contact-wa-${booking.id}`}
      >
        <MessageCircle className="w-3 h-3"/>
      </a>
    </>
  );
}
